<img [src]="useAssetsPath ? 'assets/internal-error.svg' : 'internal-error.svg'" alt="Internal error" />

<h1 class="title">{{ "internal-error.title" | translate }}</h1>

<p [innerHtml]="'internal-error.body' | translate"></p>

<div class="button-container">
	<button *ngIf="isRefreshVisible" class="refresh-button" (click)="refresh()">
		{{ "internal-error.refresh" | translate }}
	</button>
	<a *ngIf="customerSupportUrl$ | async as customerSupportUrl" [href]="customerSupportUrl" target="_blank">{{
		"customer-support.title" | translate
	}}</a>
</div>
